import {
  Autocomplete,
  Chip,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SelectSmall from "./SelectSmall";
import { USER_THANH_PHAN } from "../../services/user/userApi";

export function UserSearchBar({
  options = [],
  handleSearch = ({thanhPhan, keys}) => {},
  keys = [],
  thanhPhan = "",
  handleChange = ({thanhPhan, keys}) => {},
}) {
  return (
    <Stack spacing={2} direction={"row"} alignItems={"center"}>
      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          slotProps={{ textField: { size: "small" } }}
          label={"日付"}
          format="YYYY/MM/DD"
          value={initDay}
        />
      </LocalizationProvider> */}

      <SelectSmall
        label={"Thành phần"}
        handleChange={(v) => handleChange({ thanhPhan: v })}
        value={thanhPhan}
        options={USER_THANH_PHAN}
      />
      <Autocomplete
        size="small"
        value={keys}
        sx={{ minWidth: 300 }}
        multiple
        id="tags-outlined"
        options={options}
        freeSolo
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              size="small"
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <TextField {...params} label="Account" placeholder="Search" />
        )}
        onChange={(_e, value, _reason) => handleChange({ keys: value })}
      />
      <IconButton
        type="button"
        sx={{ p: "10px" }}
        aria-label="search"
        onClick={() => handleSearch({ thanhPhan, keys })}
      >
        <SearchIcon />
      </IconButton>
      {/* <Button
        variant="outlined"
        startIcon={<SearchIcon />}
        onClick={() => onSearch(keys)}
      >
        Search
      </Button> */}
    </Stack>
  );
}
